import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useFoodCart } from '../../hooks/useFoodCart';
import { UtensilsCrossed, ShoppingBag } from 'lucide-react';

/**
 * A mobile-only sticky bar at the bottom of every non-food page that pushes
 * diners back to `/food`. If they already have items in their cart, we show
 * the qty + subtotal and route them straight to the menu (drawer will open
 * from the cart-fab). Suppressed on admin + capture pages to avoid clutter.
 */
export default function MobileFoodSticky() {
  const { totalQty, subtotal } = useFoodCart();
  const { pathname } = useLocation();

  // Hide on: food itself, admin, capture, mira mounted overlays
  const hide = pathname.startsWith('/food')
    || pathname.startsWith('/admin')
    || pathname.startsWith('/c/')
    || pathname.startsWith('/card/')
    || pathname.startsWith('/mira')
    || pathname.startsWith('/table')
    || pathname.startsWith('/wall');
  if (hide) return null;

  return (
    <div className="md:hidden fixed inset-x-0 z-30 pointer-events-none" style={{ bottom: 0 }} aria-hidden={false}>
      <div
        className="mx-auto pointer-events-auto"
        style={{
          maxWidth: 520,
          margin: '0 auto',
          padding: '0 14px 12px',
        }}
      >
        <Link
          to="/food"
          data-testid="mobile-food-sticky"
          className="flex items-center justify-between gap-3 rounded-full px-4 py-3"
          style={{
            background: 'linear-gradient(90deg,#3A1140 0%,#531B55 100%)',
            color: '#F5EFF7',
            textDecoration: 'none',
            boxShadow: '0 12px 30px rgba(58,17,64,.35)',
            border: '2px solid rgba(232,184,75,.7)',
          }}
        >
          <span className="inline-flex items-center gap-2">
            <UtensilsCrossed size={17} color="#E8B84B" />
            <span className="text-[13.5px] font-bold">Feed your genius</span>
          </span>
          {totalQty > 0 ? (
            <span className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-[12.5px] font-bold"
                  style={{ background: '#E8B84B', color: '#3A1140' }}>
              <ShoppingBag size={13} /> {totalQty} · ₹{subtotal}
            </span>
          ) : (
            <span className="text-[12.5px] font-bold" style={{ color: '#E8B84B' }}>See menu →</span>
          )}
        </Link>
      </div>
    </div>
  );
}
